/**
 * authenticateGmail.js
 * Written by: Alex Kasemir
 */

import differenceInMinutes from 'date-fns/difference_in_minutes';
import cookie from 'react-cookies';

import event, { trackFacebookConversion, trackGoogleConversion } from 'utils/event';
import { hosts } from 'utils';
import modalActions from 'store/modal/actions';
import { updateCampaign } from '../updateCampaign';
import request from '../../../request/actions';
import { loadSession } from '../loadSession';

export const AUTHENTICATE_GMAIL_START = `AUTHENTICATE_GMAIL_START`;
export const AUTHENTICATE_GMAIL_SUCCESS = `AUTHENTICATE_GMAIL_SUCCESS`;
export const AUTHENTICATE_GMAIL_FAILURE = `AUTHENTICATE_GMAIL_FAILURE`;

export const authenticateGmailStart = () => ({
  type: AUTHENTICATE_GMAIL_START,
});

export const authenticateGmailSuccess = (token) => ({
  type: AUTHENTICATE_GMAIL_SUCCESS,
  token,
});

export const authenticateGmailFailure = (error) => ({
  type: AUTHENTICATE_GMAIL_FAILURE,
  error,
});

/**
 * Description of the authenticateGmail action
 */


export const authenticateGmail = (token) => {
  return async (dispatch) => {
    dispatch(authenticateGmailStart());
    const payload = {
      access_token: token,
    };
    try {
      const response = await dispatch(request(`/auth/google/`, `POST`, payload));
      const confirmationQueued = response.data.user.confirmation_email_queued;
      dispatch(authenticateGmailSuccess(response.data.token));
      if (differenceInMinutes(new Date(response.data.user.last_login),
        new Date(response.data.user.date_joined)) <= 1) {
        event(`user-create`, [`auth`, `user-create`, `google`]);
        trackFacebookConversion(`CompleteRegistration`, `{'content_name': 'google-sign-up'}`);
        trackGoogleConversion();
        if (confirmationQueued) {
          dispatch(modalActions.createModal({
            key: `confirm`,
            extraProps: {
              header: { text: `All set!`, img: true },
              confirmCircle: true,
              text: `Thanks for signing up! Please check your email to confirm your address. If you do not see it in your inbox, check your spam folder. The email has been sent to `,
              emailText: response.data.user.email,
            },
          }));
        } else {
          dispatch(modalActions.createModal({
            key: `welcome`,
            extraProps: {
              header: { text: `Welcome!`, img: true },
              confirmCircle: true,
              text: `Thanks for signing up! We sent your first QuizHive email to`,
              emailText: response.data.user.email,
            },
          }));
        }

        // Update Campaign Data for new user
        dispatch(updateCampaign(response.data.user.id));
      } else {
        event(`user-login`, [`auth`, `user-login`, `google`]);
      }
      cookie.save(`jwtToken`, response.data.token, {
        path: `/`,
        expires: new Date(253402300000000),
        domain: hosts.cookieDomain,
      });
      dispatch(loadSession());
    } catch (e) {
      event(`auth-failure`, [`auth`, `auth-failure`, `google`]);
      dispatch(authenticateGmailFailure(e));
    }
  };
};
